import { entries, keys } from '@wix/wix-data-client-common-standalone'

import {
  type DataBindingConnectionConfigByRole,
  type DataBindingControllerConnection,
  type DataBindingRole,
} from '../types'
import { assertNonNullable } from './assertNonNullable'
import { getControllerConnectionConfig } from './getControllerConnectionConfig'

export const generateConnectionConfigs = ({
  connectionConfigModifierByRoleByVeloId,
  controllerConnectionsByVeloId,
}: {
  connectionConfigModifierByRoleByVeloId: {
    [VeloId: string]: {
      [Role in DataBindingRole]?: (
        config: DataBindingConnectionConfigByRole[Role],
      ) => DataBindingConnectionConfigByRole[Role]
    }
  }
  controllerConnectionsByVeloId: {
    [VeloId: string]: DataBindingControllerConnection[]
  }
}): {
  [VeloId: string]: {
    [Role in DataBindingRole]?: DataBindingConnectionConfigByRole[Role]
  }
} =>
  entries(connectionConfigModifierByRoleByVeloId).reduce<
    ReturnType<typeof generateConnectionConfigs>
  >((configByRoleByVeloId, [veloId, configModifierByRole]) => {
    const configByRole = keys(configModifierByRole).reduce<{
      [Role in DataBindingRole]?: DataBindingConnectionConfigByRole[Role]
    }>(
      (configByRole, role) =>
        (<Role extends DataBindingRole>(role: Role) => {
          const config = getControllerConnectionConfig({
            connections: controllerConnectionsByVeloId[veloId],
            role,
          })
          const modifyConfig = configModifierByRole[role]
          assertNonNullable(modifyConfig)

          return { ...configByRole, [role]: modifyConfig(config) }
        })(role),
      {},
    )

    return { ...configByRoleByVeloId, [veloId]: configByRole }
  }, {})
